import { Injectable } from '@angular/core';

/**
 * Service to get or set userinfo
 */
@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  /**
   * Object stored
   */
  userInfo = null;

  /**
   * Constructor user info services
   */
  constructor() {}
  /**
   * Method to get user info     */
  public getUserInfo() {
    return this.userInfo;
  }

  /**
   * Method to set user info     */
  public setUserInfo(userInfo: null): void {
    this.userInfo = userInfo;
  }
}
